import 'src/global.css'

import React, { Suspense, useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { ErrorBoundary } from '@appsignal/react'
import { logAppVersion } from 'src/libs/qb-brand-web-components'
// import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import { hotjar } from 'react-hotjar'
import ReactGA from 'react-ga4'
import ReactPixel from 'react-facebook-pixel'
import GoogleTagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider as OldThemeProvider } from '@emotion/react'

import { getAppSignalConfig } from './constants/appConfig'
import { getIndexStore } from './store'
import { themeConfig, ThemeProvider } from './theme'
import { Snackbar } from 'src/components/snackbar'
import { ProgressBar } from 'src/components/progress-bar'
import { MotionLazy } from 'src/components/animate/motion-lazy'
import i18n from './i18n'
import { APP_CONFIG } from './constants/appConfig'
import brandConfig from 'brandConfig'
import { isRunningTesting } from './util/app/app.helpers'
import { clearCacheOnNewAppVersion } from './util/cache.helpers'
import AppRoutes from './AppRoutes'
import { defaultTheme, deepMerge } from 'src/libs/qb-brand-web-components'
import { SplashScreen } from './components/loading-screen'
// import { useServiceWorker } from './hooks/useServiceWorker'
// import AppRefresh from './components/popups/common/AppRefresh'

logAppVersion()
const getApp = async () => {
  const store = await getIndexStore()
  const App = () => {
    // useScrollToTop()
    const [userId, setUserId] = useState('')

    useEffect(() => {
      const storeUnsubscribe = store.subscribe(() => {
        const userId = store.getState().accountReducer.accountProfile.userId
        if (userId) {
          setUserId(userId)
        }
      })

      return () => {
        storeUnsubscribe()
      }
    }, [])

    const location = useLocation()
    useEffect(() => {
      clearCacheOnNewAppVersion()

      if (!isRunningTesting()) {
        // Facebook Pixel
        const facebookPixelId = APP_CONFIG.FACEBOOK_PIXEL_ID
        if (facebookPixelId) {
          ReactPixel.init(facebookPixelId, null, {
            autoConfig: true,
            debug: false
          })
          ReactPixel.pageView()
          ReactPixel.track('PageView')
        }

        // Google Tag Manager
        const googleTagManagerId = APP_CONFIG.GOOGLE_TAG_MANAGER_ID
        if (googleTagManagerId) {
          GoogleTagManager.initialize({ gtmId: googleTagManagerId })
        }

        // HotJar
        const hotjarConfig = APP_CONFIG.HOTJAR_CONFIG
        if (brandConfig.hotjarId && hotjarConfig.version) {
          hotjar.initialize(brandConfig.hotjarId, hotjarConfig.version)
        }
      }
    }, [])

    useEffect(() => {
      if (!isRunningTesting() && location) {
        // Google Analytics
        const gaTrackingId = APP_CONFIG.GA_TRACKING_ID
        if (gaTrackingId) {
          ReactGA.initialize(gaTrackingId)
          ReactGA.send({ hitType: 'pageview', page: location.pathname })
        }
      }
    }, [location])

    // @TODO: remove this before production
    // const { waitingWorker, showReload, reloadPage } = useServiceWorker()

    return (
      <ErrorBoundary {...getAppSignalConfig(userId)}>
        <HelmetProvider>
          <Provider store={store}>
            <I18nextProvider i18n={i18n}>
              <OldThemeProvider
                theme={deepMerge(defaultTheme, brandConfig.theme)}
              >
                <ThemeProvider
                  noSsr
                  defaultMode={themeConfig.defaultMode}
                  modeStorageKey={themeConfig.modeStorageKey}
                >
                  <MotionLazy>
                    <Snackbar />
                    <ProgressBar />
                    <Suspense fallback={<SplashScreen />}>
                      <AppRoutes />
                    </Suspense>
                    {/* {showReload && waitingWorker && (
                      <AppRefresh onSubmit={() => reloadPage()} />
                    )} */}
                  </MotionLazy>
                </ThemeProvider>
              </OldThemeProvider>
            </I18nextProvider>
          </Provider>
        </HelmetProvider>
      </ErrorBoundary>
    )
  }
  return App
}

export { getApp }

// function useScrollToTop() {
//   const pathname = usePathname()
//   useEffect(() => {
//     window.scrollTo(0, 0)
//   }, [pathname])
//   return null
// }
